import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_RejectionReason = _resolveComponent("RejectionReason")!
  const _component_PersonalInfo = _resolveComponent("PersonalInfo", true)!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      基本情報管理\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (_ctx.isRejected)
      ? (_openBlock(), _createBlock(_component_RejectionReason, {
          key: 0,
          details: _ctx.rejectionReasonDetails,
          comment: _ctx.rejectionReasonComment
        }, null, 8, ["details", "comment"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(_component_CustomValidationObserver, {
      tag: "div",
      class: "my-4 mx-3",
      initialValues: _ctx.formValues,
      ref: "vObserver"
    }, {
      default: _withCtx(({ handleSubmit }) => [
        _createVNode(_component_PersonalInfo, {
          modelValue: _ctx.inputValues,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValues) = $event)),
          isUnderExamination: _ctx.isUnderExamination,
          fromRegister: false
        }, null, 8, ["modelValue", "isUnderExamination"]),
        _createTextVNode(),
        _createVNode(_component_AppButton, {
          block: "",
          class: "mt-4",
          onClick: ($event: any) => (handleSubmit(_ctx.onClick)),
          disabled: _ctx.isUnderExamination
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
          ], undefined, true),
          _: 2
        }, 1032, ["onClick", "disabled"])
      ]),
      _: 1
    }, 8, ["initialValues"])
  ]))
}